import { useQuery } from '../useQuery/useQuery'
import { useAuth } from '../useAuth/useAuth'

import { getPartnerRestrictedVolunteeringConfig } from '@percent/workplace-giving/api/auth/getPartnerRestrictedVolunteeringConfig/getPartnerRestrictedVolunteeringConfig'

export const useRestrictedVolunteeringConfig = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const { state } = useAuth()

  const { data, isLoading: isBlockedRegionsLoading } = useQuery(
    ['getPartnerRestrictedVolunteeringConfig'],
    getPartnerRestrictedVolunteeringConfig,
    {
      enabled: enabled && state.status === 'authorized',
      staleTime: 1000 * 60 * 5
    }
  )

  return {
    blockedRegions: data ?? [],
    isBlockedRegionsLoading
  }
}
